import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import usePark from "common/hooks/usePark";
import { Tag } from "types/Tag";

const processOptions = (options: Tag[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

function TagSelect(props: any) {
  const { park } = usePark();
  return (
    <RemoteSelect
      url="tags"
      processOptions={(options) =>
        props.tagToExclude
          ? processOptions(
              options.filter((t: Tag) => t.id !== props.tagToExclude)
            )
          : processOptions(options)
      }
      filters={[{ name: "park][id", value: park?.id }]}
      {...props}
    />
  );
}

export default TagSelect;
